import { QueryClient } from '@tanstack/react-query';

/**
 * Shared QueryClient (WHEEL-335). Server data lives in TanStack Query hooks
 * under src/queries/ - Redux is reserved for genuine cross-page client state.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 4xx responses are definitive - retrying cannot fix them. Retry
      // network errors / 5xx once.
      retry: (failureCount, error: any) => {
        const status = error?.response?.status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
